import { FC, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/atoms/Button'

import { appConfig } from '@/services/config'
import { UserInfo } from '@/services/user'
import { usePaymentModal } from '@/lib/hooks/usePaymentModal'

interface SubscribeButtonProps {
  userInfo: UserInfo
  amount: number
}

export const SubscribeButton: FC<SubscribeButtonProps> = ({
  userInfo,
  amount,
}) => {
  const currency = appConfig.currency
  const { t } = useTranslation('common')

  const translation = {
    paymentType: t('paymentSubscription.unlockSubscription'),
    withUsername: t('paymentSubscription.withUsername', {
      username: userInfo?.username,
    }),
    price: t('paymentSubscription.labels.price'),
    republikFee: t('paymentSubscription.labels.republikFee'),
    totalPayment: t('paymentSubscription.labels.total'),
    yourWalletBalance: t('paymentSubscription.labels.yourWalletBalance'),
    pay: t('paymentSubscription.actions.pay'),
    info: t('paymentSubscription.info'),
    paymentSuccessful: t('paymentSubscription.paymentSuccessful'),
    paymentUnlockedWith: t('paymentSubscription.paymentUnlockedWith'),
    startToAction: t('paymentSubscription.actions.startToSubscribe'),
    errorSummaryTitle: t('unlockChat.errorSummaryTitle'),
    errorSummaryDetails: t('unlockChat.errorSummaryDetails'),
    close: t('unlockChat.actions.close'),
  }

  const { presentPaymentModal } = usePaymentModal({
    userInfo,
    amount,
    translation,
    paymentType: 'subscription',
  })

  const onClick = useCallback(
    (e) => {
      e.stopPropagation()
      presentPaymentModal()
    },
    [presentPaymentModal]
  )

  return (
    <Button onClick={onClick} className="mx-auto">
      <span className="text-sm px-6">
        {t('profile.subscription.subscribeButton', {
          amount,
          currency,
        })}
      </span>
    </Button>
  )
}
